import React from 'react';
import PropTypes from 'prop-types';
import Detail from './Detail';

function Details(props) {
  const { data } = props;
  return (
    <div className="">
      {data.map((detail, i) => (
        <Detail key={`details-${i}`} data={detail} />
      ))}
    </div>
  );
}
Details.propTypes = {
  data: PropTypes.array.isRequired
};

export default Details;



// WEBPACK FOOTER //
// ./src/components/Details.jsx